if (!customElements.get('knal-loop-carousel')) {
  class KnalLoopCarousel extends HTMLElement {
    constructor() {
      super();
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.scrollTimeout = null;
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
      this.disableLoop();
    }

    handleBreakpointChange() {
      if (this.mobileMediaQuery.matches) {
        this.enableLoop();
      } else {
        this.disableLoop();
      }
    }

    enableLoop() {
      if (this.querySelector('[data-carousel-clone]')) return;

      const slides = this.originalSlides;
      if (slides.length < 2) return;

      const firstClone = this.cloneSlide(slides[0]);
      const lastClone = this.cloneSlide(slides[slides.length - 1]);

      this.prepend(lastClone);
      this.append(firstClone);
      this.addEventListener('scroll', this.handleScroll, { passive: true });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scrollLeft = slides[0].offsetLeft;
        });
      });
    }

    disableLoop() {
      clearTimeout(this.scrollTimeout);
      this.removeEventListener('scroll', this.handleScroll);
      this.querySelectorAll('[data-carousel-clone]').forEach((clone) => clone.remove());
      this.scrollLeft = 0;
    }

    handleScroll() {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => this.correctLoopPosition(), 100);
    }

    correctLoopPosition() {
      const slides = Array.from(this.children);
      if (slides.length < 3) return;

      const closestSlide = slides.reduce((closest, slide) => {
        const closestDistance = Math.abs(closest.offsetLeft - this.scrollLeft);
        const slideDistance = Math.abs(slide.offsetLeft - this.scrollLeft);
        return slideDistance < closestDistance ? slide : closest;
      });

      if (closestSlide === slides[0]) {
        this.scrollLeft = slides[slides.length - 2].offsetLeft;
      } else if (closestSlide === slides[slides.length - 1]) {
        this.scrollLeft = slides[1].offsetLeft;
      }
    }

    cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.setAttribute('data-carousel-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone
        .querySelectorAll('a, button, input, select, textarea, [tabindex]')
        .forEach((element) => element.setAttribute('tabindex', '-1'));
      return clone;
    }

    get originalSlides() {
      return Array.from(this.children).filter((slide) => !slide.hasAttribute('data-carousel-clone'));
    }
  }

  customElements.define('knal-loop-carousel', KnalLoopCarousel);
}
